import {
    IRef,
} from './types';

import {
    useDefaultedRef,
} from 'tools/hooks';

export function useBigIntInputRef() {
    return useDefaultedRef<IRef>({
        setValue(): void {
            return;
        },
    });
}
